import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import validator from 'validator'
class NewHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
	marketURL: process.env.REACT_APP_CRYPTO_API_URL,
  uploaded_image_url: process.env.REACT_APP_CRYPTO_API_URL + 'images/',
  comingSoonKey: null,
    };
  }
  showComingSoon(e, key) {
    e.preventDefault();
    this.setState({ comingSoonKey: key });
    clearTimeout(this.comingSoonTimer);
    this.comingSoonTimer = setTimeout(() => this.setState({ comingSoonKey: null }), 2000);
  }
   render() {
    const _data = this.state.data;
const title = this.props.title;
const ads = this.props.ads || [];
    return (
      <div>
<header className="header-section">
          <div className="header-top  hide-mobie">
            <div className="container">

              <div className="left-box header_currency_menus">
                <a href="javascript:void(0)">
                  <span>
                    <img src={`${this.state.marketURL}img/bitcion.png`} alt="BTC" /> BTC&nbsp;
                    <span className="header_btcprice"></span> &nbsp;
                    ( <span className="header_btcper"></span>)
                  </span>
                </a>
                <a href="javascript:void(0)">
                  <span>
                    <img src={`${this.state.marketURL}img/Whitebitcoin.png`} alt="WBTC" /> WBTC&nbsp;
                    <span className="header_wbtcprice"></span> &nbsp;
                    ( <span className="header_wbtcper"></span>)
                  </span>
                </a>
                <a href="javascript:void(0)">
                  <span>
                    <img src={`${this.state.marketURL}images/1602671267.eth.png`} alt="ETH" /> ETH&nbsp;
                    <span className="header_ethprice"></span> &nbsp;
                    ( <span className="header_ethper"></span>)
                  </span>
                </a>
                <a href="javascript:void(0)">
                  <span>
                    <img src={`${this.state.marketURL}img/binance-icon.png`} alt="BNB" /> BNB&nbsp;
                    <span className="header_bnbprice"></span> &nbsp;
                    ( <span className="header_bnbper"></span>)
                  </span>
                </a>
                <a href="javascript:void(0)">
                  <span>
                    <img src={`${this.state.marketURL}images/1748429152.SOL.png`} alt="SOL" /> SOL&nbsp;
                    <span className="header_solprice"></span> &nbsp;
                    ( <span className="header_solper"></span>)
                  </span>
                </a>
              </div>


            </div>
          </div>

          <nav className="navbar navbar-expand-lg">
            <div className="container">
              <a href={this.state.marketURL} className="navbar-brand wow bounceInLeft" data-wow-duration="1.5s" style={{visibility: 'visible', animationDuration: '1.5s', animationName: 'bounceInLeft'}}><img src={`${this.state.marketURL}img/logo1.png`} alt="Logo" /></a>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#website-navbar" aria-controls="website-navbar" aria-expanded="false" aria-label="Toggle navigation">
                <i className="fa fa-bars"></i>
              </button>

              <div className="collapse navbar-collapse" id="website-navbar">

                

                <a href="javascript:void(0);" className="close-top-menu">
                  <svg
                    width="18px"
                    height="18px"
                    viewBox="0 0 18 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="Pages" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Mobile---Menu" transform="translate(-284.000000, -18.000000)" fill="#131720">
                        <path
                          d="M294,26 L304,26 L304,28 L294,28 L294,38 L292,38 L292,28 L282,28 L282,26 L292,26 L292,16 L294,16 L294,26 Z"
                          id="Combined-Shape"
                          transform="translate(293.000000, 27.000000) rotate(-45.000000) translate(-293.000000, -27.000000)"
                        />
                      </g>
                    </g>
                  </svg>
                </a>
               
                <div className="scroll-div"> 


                <div className="left-box header_currency_menus">
                  <a href="javascript:void(0)">
                    <span>
                      <img src={`${this.state.marketURL}img/bitcion.png`} alt="BTC" /> BTC
                      <span className="header_btcprice"></span>&nbsp;
                      (<span className="header_btcper"></span>)
                    </span>
                  </a>
                  <a href="javascript:void(0)">
                    <span>
                      <img src={`${this.state.marketURL}img/Whitebitcoin.png`} alt="WBTC" /> WBTC
                      <span className="header_wbtcprice"></span>&nbsp;
                      (<span className="header_wbtcper"></span>)
                    </span>
                  </a>
                  <a href="javascript:void(0)">
                    <span>
                      <img src={`${this.state.marketURL}images/1602671267.eth.png`} alt="ETH" /> ETH
                      <span className="header_ethprice"></span>&nbsp;
                      (<span className="header_ethper"></span>)
                    </span>
                  </a>
                  <a href="javascript:void(0)">
                    <span>
                      <img src={`${this.state.marketURL}img/binance-icon.png`} alt="BNB" /> BNB
                      <span className="header_bnbprice"></span>&nbsp;
                      (<span className="header_bnbper"></span>)
                    </span>
                  </a>
                  <a href="javascript:void(0)">
                    <span>
                      <img src={`${this.state.marketURL}images/1748429152.SOL.png`} alt="SOL" /> SOL
                      <span className="header_solprice"></span>&nbsp;
                      (<span className="header_solper"></span>)
                    </span>
                  </a>
                </div>

                
                <ul className="navbar-nav  ml-auto">
                <li className="nav-item ">
                  <a className="nav-link" href={this.state.marketURL+'news-list'}>News</a>
                </li>

                <li className="nav-item active">
                  <a className="nav-link" href={`${process.env.REACT_APP_MARKET_URL}`}>Market</a>
                </li>

                <li className="nav-item ">
                  <a className="nav-link my-community-link" href="javascript:void(0)" title="Coming soon" onClick={(e) => this.showComingSoon(e, 'video')}>Video</a>
                  {this.state.comingSoonKey === 'video' && (
                    <span className="coming-soon-badge">Coming soon</span>
                  )}
                </li>

                <li className="nav-item ">
                  <a className="nav-link my-community-link" href="javascript:void(0)" title="Coming soon" onClick={(e) => this.showComingSoon(e, 'podcast')}>Podcast</a>
                  {this.state.comingSoonKey === 'podcast' && (
                    <span className="coming-soon-badge">Coming soon</span>
                  )}
                </li>

                <li className="nav-item ">
                  <a className="nav-link my-community-link" href="javascript:void(0)" title="Coming soon" onClick={(e) => this.showComingSoon(e, 'community')}>My Community</a>
                  {this.state.comingSoonKey === 'community' && (
                    <span className="coming-soon-badge">Coming soon</span>
                  )}
                </li>

                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="javascript:void(0)" id="moreMenuDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More</a>
                  <div className="dropdown-menu" aria-labelledby="moreMenuDropdown">
                    <a className="dropdown-item" href={this.state.marketURL+'about-us'}>About</a>
                    <a className="dropdown-item" href={this.state.marketURL+'advertise'}>Advertise</a>
                    <a className="dropdown-item" href={this.state.marketURL+'press-media'}>Press Realeases</a>
                    <a className="dropdown-item" href={this.state.marketURL+'careers'}>Careers</a>
                    <a className="dropdown-item" href={this.state.marketURL+'partners'}>Partners</a>
                    <a className="dropdown-item" href={this.state.marketURL+'contact-us'}>Contact Us</a>
                  </div>
                </li>

                </ul>
              </div>
              </div>
            </div>
          </nav>
        </header>
        <section className="page-title1">
          <div className="container">
             <div className="advertisements">
              {ads.map((ad, index) => {
                if (ad.add_number == 29) {
                  return (
                    <div className="ad container text-center">
                        <a href={`${this.state.marketURL}advertise`} target="_blank"><img src={this.state.uploaded_image_url + ad.image} alt="Advertisement" className="img-fluid full-img mobilehide-ad" /></a>
                    </div>
                  );
                }
                else {
                  return null; // important to return something
                }
              })}
            </div>
            <div style={{padding:'20px'}}>
            <h2 className="wow bounceInDown" data-wow-duration="1.2s" style={{visibility: 'visible', animationDuration: '1.2s', animationName: 'bounceInDown', textTransform: 'capitalize'}}>{title}</h2>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default withTranslation('translations')(NewHeader);
